
export default {
  'Login': 'Login',
  'Register': 'Register',
  'Logout': 'Logout',
  'Email': 'Email',
  'Password': 'Password',
  'Confirm Password': 'Confirm Password',
  'Forgot password?': 'Forgot password?',
  'Don\'t have an account?': "Don't have an account?",
  'Already have an account?': 'Already have an account?',
  'Sign up': 'Sign up',
  'Sign in': 'Sign in',
  'Create Account': 'Create Account',
  'Join Now': 'Join Now',
  'Your email address': 'Your email address',
  'Your password': 'Your password',
  'Remember me': 'Remember me',
  'Enter your email': 'Enter your email',
  'Enter your password': 'Enter your password',
  'Seedphrase': 'Seedphrase',
  'Create a seedphrase for anonymous login': 'Create a seedphrase for anonymous login',
  'Login with Seedphrase': 'Login with Seedphrase',
  'Enter at least 6 words separated by spaces': 'Enter at least 6 words separated by spaces',
  'Use seedphrase instead of password': 'Use seedphrase instead of password',
  'Your seedphrase has been created': 'Your seedphrase has been created. Please save it somewhere safe.',
  'Seedphrase must contain at least 6 words': 'Seedphrase must contain at least 6 words',
  'Name': 'Name',
  'Your name': 'Your name',
  'Create Anonymous Account': 'Create Anonymous Account',
  'Login Anonymously': 'Login Anonymously',
  'Email & Password': 'Email & Password',
  'Anonymous (Seedphrase)': 'Anonymous (Seedphrase)',
  'Create an account with your email': 'Create an account with your email',
  'Create an anonymous account with a seedphrase': 'Create an anonymous account with a seedphrase',
  'Sign in to your account': 'Sign in to your account',
  'Create your account': 'Create your account',
  'Confirm your password': 'Confirm your password',
  'I agree to the': 'I agree to the',
  'Terms of Service': 'Terms of Service',
  'and': 'and',
  'Privacy Policy': 'Privacy Policy',
  'Loading...': 'Loading...',
  'Reset your password': 'Reset your password',
  'Enter your email address and we\'ll send you a link to reset your password.': 'Enter your email address and we\'ll send you a link to reset your password.',
  'Send reset link': 'Send reset link',
  'Cancel': 'Cancel',
  'Sending...': 'Sending...',
  'Account type': 'Account type',
  'Client': 'Client',
  'Escort': 'Escort',
  'Select your account type': 'Select your account type',
  'Choose your role': 'Choose your role'
};
